import React, { createContext, useReducer } from "react";
import { toastReducer } from "@/hooks/useToast";
import { ToastWrapper } from "Components/Common/CustomToast";


export type ToastType = "success" | "error" | "warning" | "info"
interface ToastOptions {
    type: ToastType;
    title: string;
    message: string;
    duration?: number;
}
    
interface IToastContext {
    toast: (opts: ToastOptions) => void;
    remove: (id: number | string) => void;
    add?: (toast: {
        id: string;
        title: string;
        message: string;
        type: string;
        delay?: number;
    }) => void;
}

type ToastContextProps = {
    children: React.ReactNode;
};


export type ToastProps = {
	id: string | number;
	title: string;
    message: string;
    type: ToastType;
};

export interface IToasts {
	toasts: ToastProps[]
}

const INITIAL_STATE: IToasts = {
	toasts: [],
};

export const ToastContext = createContext<IToastContext | null>(null);

export const ToastContextProvider = ({ children }: ToastContextProps) => {
    const [state, dispatch] = useReducer(toastReducer, INITIAL_STATE);

	const toast = ({ type, title, message }: ToastOptions) => {
        const id = Math.floor(Math.random() * 10000000);
        dispatch({ type: "ADD_TOAST", payload: { id, title, message, type } });
    };

	const remove = (id: string) => {
		dispatch({ type: "DELETE_TOAST", payload: id });
	};

    const value = { toast, remove };

	return <ToastContext.Provider value={value}>
		<ToastWrapper toasts={state.toasts} />
		{children}
	</ToastContext.Provider>;
};
